import Numeral from 'numeral';
import _isNil from 'lodash/isNil';
import _isNaN from 'lodash/isNaN';

var toNumeral = function toNumeral(val) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (_isNil(val) || _isNaN(val)) return Numeral(fallback);
  return Numeral(val);
};

var add = function add(val1, val2) {
  return toNumeral(val1).add(toNumeral(val2).value()).value();
};

var subtract = function subtract(val1, val2) {
  return toNumeral(val1).subtract(toNumeral(val2).value()).value();
};

var multiply = function multiply(val1, val2) {
  return toNumeral(val1, 1).multiply(toNumeral(val2, 1).value()).value();
};

var divide = function divide(val1, val2) {
  var denominator = toNumeral(val2).value();
  if (!denominator) return 0;
  return toNumeral(val1).divide(denominator).value();
};

var percent = function percent(val1, val2) {
  return multiply(divide(val1, val2), 100);
};

var mathUtils = {
  add: add,
  subtract: subtract,
  multiply: multiply,
  divide: divide,
  percent: percent
};
export default mathUtils;